import React from 'react';

const footerNavigation = {
  services: [
    { name: 'NIF', href: '/' },
    { name: 'Bank Account', href: '/bank' },
  ],
  support: [
    // { name: 'FAQs', href: 'https://support.bordr.io/' },
    { name: 'Contact', href: '/contact' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Trustpilot Reviews', href: 'https://www.trustpilot.com/review/bordr.io' },
  ],
  legal: [
    { name: 'Privacy Policy', href: 'https://www.iubenda.com/privacy-policy/93028292' },
    { name: 'Cookie Policy', href: 'https://www.iubenda.com/privacy-policy/93028292/cookie-policy' },
  ],
  social: [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/bordr.io',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
  ],
}

export default function Footer() {
  return (
    <footer className="bg-gray-900" aria-labelledby="footerHeading">
    <h2 id="footerHeading" className="sr-only">
        Footer
    </h2>
    <div className="max-w-md mx-auto py-12 px-4 sm:max-w-lg sm:pt-16 sm:px-6 lg:max-w-7xl lg:pt-16 lg:pb-16 lg:px-8">
        <div className="xl:grid xl:grid-cols-2 xl:gap-8">
          <div className="space-y-2 xl:col-span-1">
            <h4 className="text-2xl font-semibold text-white">How else can we help?</h4>
            <p className="text-gray-400 text-base">
            Let us know how we can smoothen your transition to Portugal. From purchasing your dream home to signing up for health insurance – we want to know how we should prioritize our efforts. <a href="/wishlist" className="text-white font-semibold">
            &nbsp;Send us your wishlist ➝
            </a>
            </p>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-6 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
            <div>
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">Services</h3>
                <ul className="mt-4 space-y-4">
                {footerNavigation.services.map((item) => (
                    <li key={item.name}>
                    <a href={item.href} className="text-base text-gray-400 hover:text-gray-300">
                        {item.name}
                    </a>
                    </li>
                ))}
                </ul>
            </div>
            <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">Support</h3>
                <ul className="mt-4 space-y-4">
                {footerNavigation.support.map((item) => (
                    <li key={item.name}>
                    <a href={item.href} className="text-base text-gray-400 hover:text-gray-300">
                        {item.name}
                    </a>
                    </li>
                ))}
                </ul>
            </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
            <div>
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">Bordr</h3>
                <ul className="mt-4 space-y-4">
                {footerNavigation.company.map((item) => (
                    <li key={item.name}>
                    <a href={item.href} className="text-base text-gray-400 hover:text-gray-300">
                        {item.name}
                    </a>
                    </li>
                ))}
                </ul>
            </div>
            <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">Legal</h3>
                <ul className="mt-4 space-y-4">
                {footerNavigation.legal.map((item) => (
                    <li key={item.name}>
                    <a href={item.href} className="iubenda-nostyle no-brand iubenda-embed text-base text-gray-400 hover:text-gray-300">
                        {item.name}
                    </a>
                    </li>
                ))}
                </ul>
            </div>
            </div>
        </div>
        </div>
        <div className="mt-12 border-t border-gray-700 pt-8 flex flex-row justify-between">
          <p className="text-base text-gray-400 xl:text-center">&copy; Bordr, 2021. All rights reserved.</p>
        {/* <div>
          {footerNavigation.social.map((item) => (
                <a key={item.name} href={item.href} className="text-gray-400 hover:text-gray-300">
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
          ))}
        </div> */}
        </div>
    </div>
    </footer>
  )
}
